import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const selectCsvMappingsMetadata = createSelector(
  getCompany,
  ({ csvMappingsMetadata }) => csvMappingsMetadata,
);

export const selectCsvEntityTypes = createSelector(selectCsvMappingsMetadata, Object.keys);

export const selectCsvEntityTypeFields = memoizeOne(entityType =>
  createSelector(selectCsvMappingsMetadata, csvMappingsMetadata => csvMappingsMetadata[entityType]),
);
